export default __webpack_public_path__ + "static/media/Town.41cb53df.jpg";